// extracted by mini-css-extract-plugin
export var helpText = "components-account-panels-__UserPreferences-module___helpText";
export var label = "components-account-panels-__UserPreferences-module___label";
export var languageLabel = "components-account-panels-__UserPreferences-module___languageLabel";
export var languageSelect = "components-account-panels-__UserPreferences-module___languageSelect";
export var toggle = "components-account-panels-__UserPreferences-module___toggle";
export var toggleButton = "components-account-panels-__UserPreferences-module___toggleButton";
export var toggleDescription = "components-account-panels-__UserPreferences-module___toggleDescription";
export var toggleRow = "components-account-panels-__UserPreferences-module___toggleRow";